export default __webpack_public_path__ + "static/media/decada-0060-0005-min.93dd9d35.jpg";